
import {useKeycloak} from "@react-keycloak/web";
import React from "react";
import KeycloakHelper from "../../helpers/KeycloakHelper";

const ValidAccountPage = () => {

    const { keycloak } = useKeycloak();
    const keycloakHelper = new KeycloakHelper(keycloak);

    React.useEffect(() => {
        const email = window.location.hash.replace("#", "");
        keycloakHelper.redirectToLoginWithCustomMessage("Bravo votre compte est créé avec succès !", email)
    }, [])

    return "";
}


export default ValidAccountPage;
